/* tslint:disable */
/* eslint-disable */
/* @relayHash 0d29e5cb07375051e71ac86bd6fc35e1 */

import { ConcreteRequest } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type MeasurementUnit = "CM" | "IN" | "%future added value";
export type EditPersonalProfileInput = {
    userServiceId: string;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    currency?: Currency | null;
    measurementUnit?: MeasurementUnit | null;
    zipCode?: string | null;
    shareActivities?: boolean | null;
    clientMutationId?: string | null;
};
export type changeCurrencyMutationVariables = {
    input: EditPersonalProfileInput;
};
export type changeCurrencyMutationResponse = {
    readonly editPersonalProfile: {
        readonly user: {
            readonly profile: {
                readonly currency: Currency | null;
            } | null;
        } | null;
    } | null;
};
export type changeCurrencyMutation = {
    readonly response: changeCurrencyMutationResponse;
    readonly variables: changeCurrencyMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Profile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "changeCurrencyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EditPersonalProfilePayload",
        "kind": "LinkedField",
        "name": "editPersonalProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "changeCurrencyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EditPersonalProfilePayload",
        "kind": "LinkedField",
        "name": "editPersonalProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/311.0.0-2021-04-21T17:34:53.450Z/changeCurrencyMutation",
    "metadata": {},
    "name": "changeCurrencyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '217dffcd72e935f2b56dd37a4bfdc741';
export default node;
